export const LANGUAGE_CODE = 'ja-JP';
export const MARKET_CODE = 'JPN';
export const CURRENCY_CODE = 'JPY';
export const DEFAULT_HOST = 'travel.rakuten.co.jp';
export const COMPONENT_PRICE_FILTER = 'Price_Filter';

export const IS_PACKAGE_PRICE = 'isPackagePriceFlag';
export const MIN_PRICE_FILTER_RANGE = 0;
export const MAX_PRICE_FILTER_RANGE = 100000;
export const enum FetchPriority {
  HIGH = 'high',
  LOW = 'low',
  AUTO = 'auto',
}
export const GOOGLE_Z_INDEX = {
  default: 1,
  highlighted: 2,
};
